import { render } from "./MatchingPrintLabel.vue?vue&type=template&id=4ea507da&scoped=true&ts=true&lang=pug"
import script from "./MatchingPrintLabel.vue?vue&type=script&lang=ts"
export * from "./MatchingPrintLabel.vue?vue&type=script&lang=ts"

import "./MatchingPrintLabel.vue?vue&type=style&index=0&id=4ea507da&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ea507da"]])

export default __exports__